/* eslint-disable no-redeclare */

import { z } from 'zod';

import {
  City,
  County,
  CountyFips,
  USAState,
  USAStateAcronym,
  ZipCode,
} from '../primitive';

export const Location = z.object({
  city: City,
  stateAcronym: USAStateAcronym,
  state: USAState,
  zipCode: ZipCode,
  county: County,
  countyFips: CountyFips,
});

export type Location = z.infer<typeof Location>;
